import { IntegrationCoaMapping } from "@common/schemas/domains/accounting/integrationCoaMapping.schema";
import { Task } from "@common/types/task";

export function getIntegrationCoaMappingTaskScope(task: Task) {
    return {
        entityId: task.entityIds?.[0],
        provider: task.metadata?.integrationProvider,
    };
}

export function countUnmappedMappings(
    mappings: IntegrationCoaMapping[],
): number {
    return mappings.filter((mapping) => mapping.accountId === null).length;
}
